import Axios from '@/tool/axios.js';
import {dateFormat} from '@/tool/transform.js';

export default class User {
    constructor(options) {
        options = options || {};
        for (let attr in options) {
            this[attr] = options[attr];
        }
    }

    add(data) {
        return Axios({
            url: '/api/admin/forum/createWxUser',
            method: 'post',
            data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    shopClassifyAdd() {
        return Axios({
            url: '/api/admin/forum/theme',
            method: 'post',
            data: {
                name: this.name,
                imgUrl: this.imgUrl,
                seq: this.seq
            }
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    getRealUserList(data) {
        return Axios({
            url: `/api/admin/customer`,
            method: 'get',
            params:data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    edit(id,data) {
        return Axios({
            url: `/api/admin/forum/updateVirtualUser/${id}`,
            method: 'put',
            data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    shopClassifyEdit() {
        return Axios({
            url: `/api/admin/forum/theme/${this.id}`,
            method: 'put',
            data: {
                name: this.name,
                imgUrl: this.imgUrl,
                seq: this.seq
            }
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    delete() {
        return Axios({
            url: `/api/admin/forum/theme/${this.id}`,
            method: 'delete'
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    deleteShopClassify() {
        return Axios({
            url: `/api/admin/forum/theme/${this.id}`,
            method: 'delete'
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    getOne() {
        return Axios({
            url: `/api/admin/forum/getWxUser/${this.id}`,
            method: 'get'
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    shopGetOne() {
        return Axios({
            url: `/api/admin/forum/theme/${this.id}`,
            method: 'get'
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
    getList(data) {
        return Axios({
            url: '/api/admin/forum/listForumAuthor',
            method: 'get',
            params:data
        }).then(
            res => {
                res.data.data = res.data.data || [];
                let list = res.data.data;
                list.map(item => {
                    item.createdAt = dateFormat(item.createdAt);
                });
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }
    getShopClassifyList() {
        return Axios({
            url: '/api/admin/forum/theme',
            method: 'get'
        }).then(
            res => {
                res.data.data = res.data.data || [];
                let list = res.data.data;
                list.map(item => {
                    item.createdAt = dateFormat(item.createdAt);
                });
                return Promise.resolve(res);
            },
            err => Promise.reject(err)
        );
    }

    upload(data) {
        return Axios({
            url: '/teaCircleParty/api/upload/unCheck',
            method: 'post',
            isUpload: true,
            data
        }).then(
            res => Promise.resolve(res),
            err => Promise.reject(err)
        );
    }
}
